const CANCEL_FLOW_EXPERIENCE = 'Cancel Flow';

export default CANCEL_FLOW_EXPERIENCE;
